import FormValidation from "../../Validation/FormValidation";

const Radio = {

    bind(form) {
        this.input = '.input.radio';
        form.find(this.input).on('change', (evt) => {
            FormValidation.setValid($(evt.currentTarget), true);
        });
    },

    check(form) {
        let ok = true;
        let inputOk = false;

        form.find(this.input).each((i, el) => {
            $(el).find('input[type="radio"]').each((i, input) => {
                if (this.isValid($(input))) {
                    inputOk = true;
                    return false;
                }
            })

            ok &= inputOk;
            FormValidation.setValid($(el), inputOk, true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');

        if (isRequired) return input.prop('checked');
        else return true;
    },
}

export default Radio;

